import TrustpilotWidget from './TrustpilotWidget.jsx'
import ReviewsIoWidget from './ReviewsIoWidget.jsx'
import FeefoWidget from './FeefoWidget.jsx'

const RatingWidget = ({ partner }) => {
  if (partner.ratingProvider === 'trustpilot' && partner.trustpilotId)
    return <TrustpilotWidget businessUnitId={partner.trustpilotId} />
  if (partner.ratingProvider === 'reviews_io' && partner.reviewsIoId)
    return <ReviewsIoWidget storeId={partner.reviewsIoId} />
  if (partner.ratingProvider === 'feefo' && partner.feefoId)
    return <FeefoWidget merchantId={partner.feefoId} />
  return null
}

const BUSINESS_TYPE_LABELS = {
  conveyencer: 'Conveyancing',
  'mortgage-broker': 'Mortgage broker',
  photographer: 'Photography / Videography',
  'moving-or-storage': 'Removals & storage',
  'floorplan-services': 'Floorplans',
  advertiser: 'Partner',
}

const BUSINESS_SITE_URL = 'https://business.keyzee.co.uk'

const ListingsAdPlaceholder = ({ variant = 'grid', partner = null, onLearnMore = null }) => {
  if (variant === 'list') {
    if (partner) {
      return (
        <article className="listings-list__item listings-list__item--ad listings-list__item--ad-live">
          <div
            className="listings-ad__hero-banner"
            onClick={onLearnMore ? () => onLearnMore(partner) : undefined}
            style={onLearnMore ? { cursor: 'pointer' } : undefined}
            role={onLearnMore ? 'button' : undefined}
            aria-label={onLearnMore ? `Learn more about ${partner.name}` : undefined}
            tabIndex={onLearnMore ? 0 : undefined}
            onKeyDown={onLearnMore ? (e) => e.key === 'Enter' && onLearnMore(partner) : undefined}
          >
            {partner.logoUrl ? (
              <img
                src={partner.logoUrl}
                alt={`${partner.name} logo`}
                className="listings-ad__hero-img"
                loading="lazy"
              />
            ) : (
              <span className="listings-ad__hero-placeholder" aria-hidden="true">
                {(partner.name || '?').slice(0, 1).toUpperCase()}
              </span>
            )}
          </div>
          <div className="listings-list__ad-content listings-list__ad-content--live">
            <p className="listings-list__ad-eyebrow">Sponsored</p>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.4rem', flexWrap: 'wrap' }}>
              <strong className="listings-ad__name">{partner.name}</strong>
              {partner.businessType ? (
                <span className="pill listings-ad__type-pill">
                  {BUSINESS_TYPE_LABELS[partner.businessType] || partner.businessType}
                </span>
              ) : null}
            </div>
            {partner.tagline ? (
              <p className="listings-ad__tagline">{partner.tagline}</p>
            ) : null}
            <RatingWidget partner={partner} />
            {onLearnMore ? (
              <button type="button" className="ghost-button listings-ad__cta" onClick={() => onLearnMore(partner)}>
                Learn more
              </button>
            ) : (
              <a
                href={BUSINESS_SITE_URL}
                target="_blank"
                rel="noreferrer noopener"
                className="ghost-button listings-ad__cta"
              >
                Learn more
              </a>
            )}
          </div>
        </article>
      )
    }

    return (
      <article className="listings-list__item listings-list__item--ad">
        <div className="listings-list__ad-content">
          <p className="listings-list__ad-eyebrow">Sponsored spotlight</p>
          <h3>Premium partner placement</h3>
          <p>Reserve this slot to showcase a service, partner listing, or featured promotion alongside buyer searches.</p>
          <button type="button" className="ghost-button" disabled>
            Coming soon
          </button>
        </div>
      </article>
    )
  }

  if (partner) {
    return (
      <article className="property-card property-card--ad property-card--ad-live" aria-label="Sponsored placement">
        <div
          className="property-card__ad-hero"
          onClick={onLearnMore ? () => onLearnMore(partner) : undefined}
          style={onLearnMore ? { cursor: 'pointer' } : undefined}
          role={onLearnMore ? 'button' : undefined}
          aria-label={onLearnMore ? `Learn more about ${partner.name}` : undefined}
          tabIndex={onLearnMore ? 0 : undefined}
          onKeyDown={onLearnMore ? (e) => e.key === 'Enter' && onLearnMore(partner) : undefined}
        >
          {partner.logoUrl ? (
            <img
              src={partner.logoUrl}
              alt={`${partner.name} logo`}
              className="property-card__ad-hero-img"
              loading="lazy"
            />
          ) : (
            <span className="property-card__ad-hero-placeholder" aria-hidden="true">
              {(partner.name || '?').slice(0, 1).toUpperCase()}
            </span>
          )}
          <span className="property-card__ad-eyebrow">Sponsored</span>
        </div>
        <div className="property-card__ad">
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.4rem', flexWrap: 'wrap' }}>
            <strong className="listings-ad__name">{partner.name}</strong>
            {partner.businessType ? (
              <span className="pill listings-ad__type-pill">
                {BUSINESS_TYPE_LABELS[partner.businessType] || partner.businessType}
              </span>
            ) : null}
          </div>
          {partner.tagline ? (
            <p className="listings-ad__tagline">{partner.tagline}</p>
          ) : null}
          <RatingWidget partner={partner} />
          {onLearnMore ? (
            <button type="button" className="ghost-button listings-ad__cta" onClick={() => onLearnMore(partner)}>
              Learn more
            </button>
          ) : (
            <a
              href={BUSINESS_SITE_URL}
              target="_blank"
              rel="noreferrer noopener"
              className="ghost-button listings-ad__cta"
            >
              Learn more
            </a>
          )}
        </div>
      </article>
    )
  }

  return (
    <article className="property-card property-card--ad" aria-label="Sponsored placement">
      <div className="property-card__ad">
        <p className="property-card__ad-eyebrow">Sponsored</p>
        <h3>Featured placement</h3>
        <p>Invite partners or premium listings to appear here. Stays consistent with the surrounding cards.</p>
        <button type="button" className="ghost-button" disabled>
          More soon
        </button>
      </div>
    </article>
  )
}

export default ListingsAdPlaceholder
